import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DowngradeStatusResponse } from '../models/downgrade-response.model';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainDowngradeService {


  serviceUrl: string = environment.serviceurl
  subscriptionUrl: string = this.serviceUrl + 'api/subscriptions/'
  
  private downgradeStatusSubject = new BehaviorSubject<DowngradeStatusResponse | null>(null);
  public downgradeStatus$ = this.downgradeStatusSubject.asObservable();

  constructor(private http: HttpClient) { }

  setDowngradeStatus(status: DowngradeStatusResponse | null) {
    this.downgradeStatusSubject.next(status);
  }

  public loadDowngradeStatus(
    userId: string | number,
    force: boolean = false
  ): void {
    if (!this.downgradeStatusSubject.value || force) {
      this.getDowngradeStatus(userId).subscribe({
        next: (data: DowngradeStatusResponse) => {
          this.downgradeStatusSubject.next(data);
        },
        error: (err) => {
          console.error('Error fetching downgrade status:', err);
          // Set to a default object or handle the error appropriately
          // Using any here as a fallback mechanism for the subject
          this.downgradeStatusSubject.next({} as DowngradeStatusResponse);
        },
      });
    }
  }

  userDowngradeFeedback(data: any) {
    return this.http.post(this.subscriptionUrl + 'feedback/downgrade/', data)
  }

  getDowngradeStatus(userId: number | string): Observable<DowngradeStatusResponse> {
    const endpoint = `${this.subscriptionUrl}downgrade-status/${userId}/`;
    return this.http.get<DowngradeStatusResponse>(endpoint);
  }

}

